module.exports = "/images/ico-classic-grey.png?5c29c1399ad9573bf74c52a459f2e825";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/ico-classic-grey.png
// module id = hlHl
// module chunks = 1